import { tryValidateURL } from 'utilities';
import { findIndexByPropertyValue } from 'utilities/collection';

export function checkValueIsURL(value) {

  return tryValidateURL(value);

}

export function removeElementFromCollection(collection, value) {

  const elementIndex = findIndexByPropertyValue(collection, '_id', value);

  if (elementIndex !== -1) {
    collection.splice(elementIndex, 1);
  }

  return collection;

}